import React, { useEffect, useRef, useState } from "react";
import AddIcon from "@mui/icons-material/Add";
import InputSelect from "../../components/input/InputSelect";
import CloseIcon from "@mui/icons-material/Close";

import { useDispatch } from "react-redux";
import { setcollectionPopup } from "../../redux/features/stylesSlice";
import {
  setBookmarkUrls,
  setBookmarkData,
  setCollections,
  setCitationPopup,
  setSummarizePopup,
  setArticleDataCitation,
  setSummaryInfoData,
} from "../../redux/features/dataSlice";
import { getConfig, searchAPI } from "../../apis";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import ButtonPrimary from "../../components/button/ButtonPrimary";
import { logEvent } from "../../functions/amplitude";
import Draggable from "react-draggable";
import { useIsMobile } from "../../functions/isMobile";
import { axiosInstance } from "../../functions/axios";

const PopupSave = (props) => {
  const {
    data,
    bookmarkUrls,
    setNewBookmarkPopup,
    selectedCollection,
    setselectedCollection,
    popup,
    desc,
    setpopup,
    setData,
    handleSavedCollection,
  } = props;
  const dispatch = useDispatch();

  const divRef = useRef();

  const { user } = useSelector((state) => state.auth);
  const { collections, summaryInfoData } = useSelector((state) => state.data);
  const [position, setPosition] = useState({
    marginTop: 0,
    marginLeft: 0,
  });

  const handleClose = () => {
    dispatch(setSummarizePopup(false));
    setData({});
    dispatch(setSummaryInfoData({}));

    setpopup(false);
  };

  const isMobile = useIsMobile();

  const getEntityName = () => {
    if (data.displayUrl.includes("britannica")) return "Britannica";
    if (data.displayUrl.includes("books")) return "Google Books";
    return "Merriam Webster";
  };

  const entityName = () => {
    const source = summaryInfoData.publisher
      ? summaryInfoData.publisher
      : getEntityName();

    return source;
  };

  const saveCollection = async () => {
    let date, source, title, sourceURL;

    if (!Object.values(summaryInfoData).every((value) => value === "")) {
      date = summaryInfoData.published_date
        ? new Date(summaryInfoData.published_date)
        : null;
      source = summaryInfoData.publisher;
      title = summaryInfoData.title;
      sourceURL = summaryInfoData.url;
    } else if (data) {
      date = data.publishedDate ? new Date(data.publishedDate) : null;
      source = entityName();
      sourceURL = data.displayUrl;
      title = data.title;
    }

    if (selectedCollection) {
      const selectedCollectionData = JSON.parse(selectedCollection);
      const json_res = {
        callingUserId: user.userId,
        userId: user.userId,
        collectionId: selectedCollectionData.collectionId,
        title: title,
        sourceName: source,
        sourceURL: sourceURL,
        sourcePublishedDateTime: date,
        summary: desc,
      };

      try {
        const res = await axiosInstance.post(
          searchAPI.AddUpdateCollectionsSource,
          json_res,
          getConfig()
        );

        if (data.citationMeta) {
          handleSavedCollection(res.data);
          dispatch(setCitationPopup(false));
          dispatch(setArticleDataCitation({}));
        }

        if (bookmarkUrls && !bookmarkUrls.includes(sourceURL)) {
          const newUrls = [...bookmarkUrls, sourceURL];
          dispatch(setBookmarkUrls(newUrls));
        }

        toast.success("Saved to collection");
        handleClose();
        const amplitude_bookmark = {
          publication: source,
          bookmarkurl: title,
        };

        logEvent("click_bookmark_save", amplitude_bookmark);
      } catch (error) {
        console.log(error);
        toast.error("Something went wrong, please try later.");
      }
    } else {
      toast.error("Please select a folder");
      console.log(selectedCollection);
    }
  };

  const handleKeyDown = (event) => {
    if (selectedCollection) {
      if (event.key === "Enter") {
        setpopup(!popup);
        saveCollection();
      }
    } else {
      toast.error("Please select a folder");
    }
  };

  const handleDrag = (e, ui) => {
    const { x, y } = ui;
    setPosition((prevPosition) => ({
      ...prevPosition,
      marginTop: y,
      marginLeft: x,
    }));
  };

  useEffect(() => {
    if (popup) {
      async function getData() {
        const res = await axiosInstance.post(
          searchAPI.getCollections,
          {
            callingUserId: user.userId,
            userId: user.userId,
          },
          getConfig()
        );

        let newArr = [];
        res.data.forEach((item) =>
          newArr.push({
            name: item.collectionName_chr,
            value: item.collectionName_chr,
            collectionId: item.collectionID_ids,
            parentCollectionId: item.parentCollectionID_lng,
          })
        );

        dispatch(setCollections(newArr.reverse()));
        setselectedCollection(JSON.stringify(newArr[0]));
      }
      getData();
    }
  }, [popup]);

  useEffect(() => {
    if (popup) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "visible";
    }
  }, [popup]);

  useEffect(() => {
    if (divRef.current) {
      setTimeout(() => {
        divRef.current.focus();
      }, 50);
    }
  }, []);

  return (
    <div
      className="popup-wikipedia-save"
      // on
    >
      {popup && (
        <>
          {" "}
          <div className="bg-dark" />
          <div
            // onKeyDown={(e) => handleKeyDown(e)}
            // tabIndex={0}
            className="popover-save"
            // ref={divRef}
          >
            <div className="popup-card">
              <CloseIcon className="cross" onClick={() => setpopup(false)} />

              <p className="popup-title">Add to Collection</p>
              <InputSelect
                name=""
                icon
                valueKey="collectionId"
                options={collections}
                value={selectedCollection}
                onChange={(e) => setselectedCollection(e.target.value)}
              />
              <div className="flex-end save-actions">
                <ButtonPrimary
                  text="More..."
                  outline
                  onClick={() => {
                    dispatch(setcollectionPopup(true));
                    dispatch(
                      setBookmarkData({ ...data, entityName: entityName() })
                    );
                    setpopup(false);
                  }}
                />
                <div className="flex">
                  <ButtonPrimary
                    text="Create"
                    className="mr-2"
                    iconLeft={<AddIcon />}
                    outline
                    onClick={() => setNewBookmarkPopup(true)}
                  />{" "}
                  <ButtonPrimary text="Save" onClick={saveCollection} />
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default PopupSave;
